// Single source of truth for white-label brand identity. Name is a build-time
// Vite env var (VITE_BRAND_NAME, see apps/ai-assessment/Dockerfile) so the
// same codebase can serve different deployments under different brands
// without a source fork. Falls back to "Claritio" so a build with the var
// unset (e.g. a local `vite build`) still carries our own identity.
//
// The mark itself lives in components/Logo.tsx (drawn from --brand-mark);
// `public/favicon.svg` and the other static icons carry the same outline and
// are swapped per deployment, since they're served statically, not built.
//
// NOTE: this is *identity* only (name shown in chrome/logo/title). Brand-voice
// copy in the product ("your Claritio consultant", "Claritio will analyse…")
// lives in the locale files and is interpolated against `BRAND.name` there.
const brandName = (import.meta.env.VITE_BRAND_NAME as string | undefined)?.trim() || 'Claritio'

export const BRAND = {
  name: brandName,
  productName: brandName,
  platformLabel: 'Platform',
} as const
